import { render } from "./PuntoVentaList.vue?vue&type=template&id=86a3584a&scoped=true"
import script from "./PuntoVentaList.vue?vue&type=script&lang=js"
export * from "./PuntoVentaList.vue?vue&type=script&lang=js"

import "./PuntoVentaList.vue?vue&type=style&index=0&id=86a3584a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a3584a"]])

export default __exports__